import { makeStyles } from "tss-react/mui";

import {
  actionDanger,
  actionPrimary,
  actionSecondary,
} from "@/shared/styles/action.styles";

const styles = makeStyles()((theme) => ({
  body: {
    "& .MuiPaper-root": {
      backgroundColor: theme.design.color.surface.raised,
      color: theme.design.color.text.primary,
      borderRadius: theme.design.radius.lg,
      fontFamily: theme.design.typography.fontFamily,
      border: `1px solid ${theme.design.color.border.popover}`,
      boxShadow: theme.design.shadow.lg,
      overflow: "hidden",
    },

    "& .MuiDialog-paper": {
      overflowY: "visible",
    },

    [theme.breakpoints.down("sm")]: {
      "& .MuiPaper-root": {
        margin: theme.design.space.lg,
        maxHeight: "calc(100vh - 32px)",
        borderRadius: theme.design.radius.lg,
      },
      "& .MuiDialog-paper": {
        maxHeight: "calc(100vh - 32px)",
        overflowY: "auto",
      },
    },
  },

  modalContent: {
    position: "relative",
    width: 380,
    maxWidth: "100%",

    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },

  closeButton: {
    position: "absolute",
    right: theme.design.space.sm,
    top: theme.design.space.sm,
    zIndex: 1,
    padding: theme.design.space.xs,
    color: theme.design.color.text.secondary,
    borderRadius: theme.design.radius.md,
    transition: [
      `color ${theme.design.motion.duration.fast}`,
      `background-color ${theme.design.motion.duration.fast}`,
    ].join(", "),
    "&:hover": {
      color: theme.design.color.text.primary,
      backgroundColor: theme.design.color.overlay.white10,
    },
    "&:focus-visible": {
      boxShadow: theme.design.shadow.focus,
    },
    "& svg": {
      width: theme.design.size.icon.md,
      height: theme.design.size.icon.md,
    },
  },

  contentBody: {
    display: "flex",
    flexDirection: "column",
    gap: theme.design.space.md,
    padding: `${theme.design.space.xl}px ${theme.design.space.xl}px ${theme.design.space.lg}px`,

    [theme.breakpoints.down("sm")]: {
      padding: `${theme.design.space.xl}px ${theme.design.space.lg}px max(${theme.design.space.lg}px, env(safe-area-inset-bottom))`,
    },
  },

  title: {
    fontFamily: theme.design.typography.fontFamily,
    fontSize: theme.design.typography.size.titleSmall,
    fontWeight: 900,
    color: theme.design.color.text.primary,
    lineHeight: theme.design.typography.lineHeight.compact,
    paddingRight: theme.design.space.xl,
  },

  description: {
    fontFamily: theme.design.typography.fontFamily,
    fontSize: theme.design.typography.size.bodySmall,
    fontWeight: 400,
    color: theme.design.color.text.muted,
    lineHeight: theme.design.typography.lineHeight.default,
  },

  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.design.space.sm,
    width: "100%",
    marginTop: theme.design.space.xs,
  },

  cancelButton: {
    ...actionSecondary(theme),
    minWidth: 96,
    minHeight: theme.design.size.control.md,
    padding: `${theme.design.space.sm}px ${theme.design.space.lg}px`,
    fontSize: theme.design.typography.size.bodySmall,
    "&:focus-visible": { boxShadow: theme.design.shadow.focus },
  },

  confirmButton: {
    minWidth: 112,
    minHeight: theme.design.size.control.md,
    padding: `${theme.design.space.sm}px ${theme.design.space.lg}px`,
    fontSize: theme.design.typography.size.bodySmall,
    "&:focus-visible": { boxShadow: theme.design.shadow.focus },
  },

  confirmPrimary: {
    ...actionPrimary(theme),
  },

  confirmDanger: {
    ...actionDanger(theme),
  },
}));

export default styles;
